const api = {
    createUser: {
        register: {
            permanent: '/api/prt/cus/reg/perm',
        },

    },
    common: {
        login: '/api/prt/cmn/lin/uinf',
        logout: '/api/prt/cmn/lin/lout',
        userData: '/api/prt/cmn/uinf/get',
        changePassword: '/api/prt/cmn/pwd/chg',

        getTerms: '/api/prt/cmn/terms/get',
        agreeTerms: '/api/prt/cmn/uinf/agree',
        topPageData: '/api/prt/cmn/info/get',
        fetchTopPageFAQ: '/api/prt/cmn/qa/get'
    },
    user:{
        dashboard: {
            getData: '/api/prt/tus/dbd/get',
            getNotificationDetail: '/api/prt/tus/inf/get'
        },
        installer: {
            office: '/api/prt/tus/adl/ofc',
            home: '/api/prt/tus/adl/home',
            homeMac: '/api/prt/tus/adl/home_mac',
        },
        appConfig: {
            getSettings: '/api/prt/tus/aset/get',
            setSettings: '/api/prt/tus/aset/set',
        },
        userConfig: {
            chgEmailHome: '/api/prt/tus/inf/shem',
        },
        onetimePass: {
            office: '/api/prt/tus/aop/sndo',
            home: '/api/prt/tus/aop/sndh',
            isAvailable: '/api/prt/tus/aop/sget'
        },
        question: {
            getList: '/api/prt/tus/inq/clst',
            submit: '/api/prt/tus/inq/add'
        },
        qanda: {
            getIndex: '/api/prt/tus/qa/getq',
            getDetail: '/api/prt/tus/qa/getqd'
        }
    },
    tenantAdmin: {
        downloadApplicationPaper: '/api/prt/tad/dl/af',
        dashboard: {
            getData: '/api/prt/tad/dbd/get',
            getNotificationDetail: '/api/prt/tad/inf/get'
        },
        settings:{
            banNetworks: {
                list: '/api/prt/tad/fba/list',
                create: '/api/prt/tad/fba/add',
                delete: '/api/prt/tad/fba/del',
                edit: '/api/prt/tad/fba/set'
            },
            appSettings: {
                getData: '/api/prt/tad/aset/get',
                editData: '/api/prt/tad/aset/set',
            },
            securitySettings: {
                getData: '/api/prt/tad/sec/get',
                editData: '/api/prt/tad/sec/set'
            }
        },
        userList: {
            list: '/api/prt/tad/uinf/ulist',
            userDetail: '/api/prt/tad/uinf/pcdet',
            usersLog: '/api/prt/tad/uinf/llist',  
            userEdit: '/api/prt/tad/uinf/set',
            userCreate: '/api/prt/tad/uinf/add',
            resetPassword: '/api/prt/tad/uinf/rpw',
            downloadUserCsv: '/api/prt/tad/uinf/dlcsv',
            downloadGooglePlayCsv: '/api/prt/sad/and_ulist/download',
            uploadGooglePlayCsv: '/api/prt/sad/and_ulist/upload',
            deleteUser: '/api/prt/tad/uinf/deluser',
            userCreateInfo: '/api/prt/tad/uinf/ucnt'
        },
        logview: {
            list: '/api/prt/tad/log/get',
            getCategoryList: '/api/prt/tad/log/prop',
            downloadCsvLogList: '/api/prt/tad/log/dlcsv'
        },
        questionList: {
            list: '/api/prt/tad/inq/list',
            questionDetail: '/api/prt/tad/inq/get',
            questionEdit: '/api/prt/tad/inq/set',
            addQuestion: '/api/prt/tad/inq/add',
            getCategoryList: '/api/prt/tad/inq/cat',
            downloadAttachFile: '/api/prt/tad/inq/dlat',
            downloadAdminFile: '/api/prt/tad/inq/dladmin',
        },
        stats: {
            getCurrentStats: '/api/prt/tad/use/cnt',
            getDailyUsingCounts: '/api/prt/tad/logagg/get',
            getHourlyUsingUserNumber: '/api/prt/tad/conagg/get',
            downloadCsvDailyUsingCounts: '/api/prt/tad/logagg/dlcsv',
            downloadCsvHourlyUsingUserNumber: '/api/prt/tad/conagg/dlcsv'
        },
        qanda: {
            getIndex: '/api/prt/tad/qa/getq',
            getDetail: '/api/prt/tad/qa/getqd'
        }
    },
    systemAdmin: {
        stats: {
            getCurrentStats: '/api/prt/sad/use/cnt',
            getDailyUsingCounts: '/api/prt/sad/logagg/get',
            getHourlyUsingUserNumber: '/api/prt/sad/conagg/get',
            getTenantList: '/api/prt/sad/tenantagg/list',
            downloadCsvDailyUsingCounts: '/api/prt/sad/logagg/dlcsv',
            downloadCsvHourlyUsingUserNumber: '/api/prt/sad/conagg/dlcsv',
            downloadCsvTenantList: '/api/prt/sad/tenantagg/dlcsv'
        },
        questionList: {
            getTenantList: '/api/prt/sad/inq/list',
        },
        informations: {
            delete: '/api/prt/sad/infapp/del',
            register: '/api/prt/sad/infapp/add',
            edit: '/api/prt/sad/infapp/set',
            getList: '/api/prt/sad/infapp/list',
            getDetail: '/api/prt/sad/infapp/det',
            getTargetList: '/api/prt/sad/infapp/target',
            getTemplateList: '/api/prt/sad/infapp/template'
        }
    },
}

export default ({ app }, inject) => {
    inject('api', api);
}